import { EMPTY_LIST } from '../../../../../constants/common'
import { UserMultiValuedList } from '../../../../User'

import {
  VIEWING_APPLICANTS_INFO_ITEM_ATTRIBUTE,
  VIEWING_APPLICANTS_INFO_VISIBLE_COUNT,
} from './ViewingApplicantsInfoValue.constants'
import {
  getIsViewingApplicantClickable,
  getViewingApplicantById,
  toViewingApplicantMultiValue,
} from './ViewingApplicantsInfoValue.utils'

import * as styles from './ViewingApplicantsInfoValue.module.css'

function ViewingApplicantsInfoValue({
  applicants = EMPTY_LIST,
  onClickApplicant,
}) {
  function handleClickItem(event) {
    const applicant = getViewingApplicantById({
      applicantId: event.currentTarget.getAttribute(
        VIEWING_APPLICANTS_INFO_ITEM_ATTRIBUTE
      ),
      applicants,
    })

    if (getIsViewingApplicantClickable(applicant)) {
      onClickApplicant(applicant)
    }
  }

  return (
    <UserMultiValuedList
      className={styles.ViewingApplicantsInfoValue}
      filter={null}
      items={applicants.map(toViewingApplicantMultiValue)}
      visibleCount={VIEWING_APPLICANTS_INFO_VISIBLE_COUNT}
      onClickItem={handleClickItem}
    />
  )
}

export default ViewingApplicantsInfoValue
